import React, { ComponentType } from 'react';
import AuthContext from './Context';
import { IWithAuth } from './types';

const withAuth = <T extends {}>(Component: ComponentType<T & IWithAuth>) => (props: T) => (
  <AuthContext.Consumer>
    {(providerProps: IWithAuth) => <Component {...props} {...providerProps} />}
  </AuthContext.Consumer>
);

export default withAuth;
